import { render, staticRenderFns } from "./CompanyData.vue?vue&type=template&id=2dfdb33d&scoped=true"
import script from "./CompanyData.vue?vue&type=script&lang=ts"
export * from "./CompanyData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfdb33d",
  null
  
)

export default component.exports